import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const Wrapper = styled.div`
  border-radius: 8px;
  background-color: ${th('colors.confetti+4')};

  @media ${sizes.desktop} {
    border-radius: 16px;
  }
`;

export const AddWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
  font-weight: 500;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${th('colors.confetti')};
`;
